import React, { useCallback, useEffect, useState } from "react";
import Login from "../components/Login/Login";
import { useNavigate } from "react-router-dom";
import { login } from "../apis";

export default function LoginContainer() {
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState({
    username: "",
    password: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/service-settings");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
  };

  const handleLogin = useCallback(async () => {
    if (!inputValue.username.trim() || !inputValue.password.trim()) {
      alert("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    try {
      const res = await login(inputValue);
      localStorage.setItem("token", res.data.token);
      navigate("/service-settings");
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "로그인 실패");
    }
  }, [inputValue, navigate]);

  // ✅ Enter 키 입력 시 로그인 실행
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Login
      inputValue={inputValue}
      handleLogin={handleLogin}
      handleChange={handleChange}
      handleKeyDown={handleKeyDown}
    />
  );
}
